import React, { useState } from 'react';
import Icon from "../media/icon/icons.jsx";
import '../styles/component.css';
import { Input } from './utilitis/Input.jsx';
import AxipaysLogo from '../media/image/axi_wideLogo.png';
import BoyAvtar from '../media/image/profileimage.jpg';
import NotificationPopup from '../components/NotificationPopup.jsx';
import ProfileDropdown from "../components/ProfileDropdown.jsx";

function Header() {
    const userName = sessionStorage.getItem("userName");
    const email = sessionStorage.getItem("email");
    const userRole = sessionStorage.getItem("role");
    const clientId = sessionStorage.getItem("clientId");

    // const [isFlip, setFlip] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [dropdownResults, setDropdownResults] = useState([]);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // ✅ mobile toggle
   const [isNotificationOpen, setNotificationOpen] = useState(false);
    const [isProfileOpen, setProfileOpen] = useState(false);

    const [notificationCount, setNotificationCount] = useState(0);


//      const toggleFlip = () => {
//     setFlip((prev) => !prev);
//   };

    // const openModal = (type) => {
    //     setModalType(type);
    //     setIsModalOpen(true);
    // };

    // const closeModal = () => {
    //     setIsModalOpen(false);
    //     setFlip(false);
    // };

    // const handleSearchInput = (field, value) => {
    //     setSearchQuery(value);
    //     if (value.trim() !== "") {
    //         const filteredResults = sampleData.filter((item) =>
    //             item.toLowerCase().includes(value.toLowerCase())
    //         );
    //         setDropdownResults(filteredResults);
    //     } else {
    //         setDropdownResults([]);
    //     }
    // };

    const handleSearchInput = (value) => {
      const newIds = value
        .trim()
        .split(/\s+/)
        .filter((id) => id);
     setSearchQuery(newIds);

      const apiEndpoint = `api/v1/txn/search`;
};
    return (
        <>
            <div className={userRole === 'firstUser' ? 'portal-header portal-header-firstuser' : 'portal-header'}>
                  <div className="mobile-menu-icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                <Icon name="menu" width={24} height={24} color="#003366" />
            </div>
                {/* <div className={modalType === 'Search' ? "header-modal-div md-search" : "header-modal-div"}>
                    <Modal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        modalType={modalType}
                        searchQuery={searchQuery}
                    />
                </div> */}

                {/* ✅ Responsive wrapper for input + profile */}
                <div className={`header-main-content ${mobileMenuOpen ? 'show-mobile' : ''}`}>
                    <div className='header-main-div'>
                        {userRole === 'firstUser' ? (
                            <div className="logo-section">
                                <img src={AxipaysLogo} alt="Logo" className="demo-logo" />
                            </div>
                        ) : (
                            <div className="input-grp">
                                <div className="ic">
                                    <Icon name="search" width={22} height={22} color="#003366" />
                                </div>
                                <Input
                                    type="text"
                                    placeholder="Quick Search"
                                    id="search"
                                    value={searchQuery}
                                    onChange={(value) => handleSearchInput(value)}
                                />
                                <div className='ic'>
                                    <Icon name="commandline" width={25} height={25} color="#003366" />
                                </div>
                            </div>
                        )}
                    </div>
                             <div className='header-functionality'>

                                    <div className="header-notification">
                                    {userRole !== "firstUser" && userRole !== "client" && (
                                    <>
                                    <div
                                        className="ic notification-bell"
                                        onClick={() => {
                                        setNotificationOpen(true);
                                        setProfileOpen(false);
                                        }}
                                    >
                                        <Icon name="bell" width={25} height={25} color="#003366" />
                                        {notificationCount > 0 && (
                                        <span className="notification-dot"></span>
                                        )}
                                    </div>

                                    <NotificationPopup
                                        isOpen={isNotificationOpen}
                                        onClose={() => setNotificationOpen(false)}
                                        setNotificationCount={setNotificationCount} 
                                    />
                                    </>
                                )}
                                </div>

                         <div className='profileSection' onClick={() => {setProfileOpen(true);
                            setNotificationOpen(false)}
                                }>
                            <div className='img-section'>
                                {userRole === "admin" ? (
                                    <img src={BoyAvtar} alt="avatar" />
                                ) : (
                                    <div>
                                        {userName ? userName.charAt(0).toUpperCase() : "U"}
                                    </div>
                                )}
                            </div>
                            <div className='details-section'>
                                <p className='userName'>{userName}</p>
                                <p className='userRole'>{email}</p>
                            </div>
                          

                                <ProfileDropdown
                                isOpen={isProfileOpen}
                                onClose={() => setProfileOpen(false)}
                                clientId={clientId}
                                />

                                <div className="dropDown-section" onClick={() => setProfileOpen((prev) => !prev)}>
                                <div className="ic">
                                    <Icon
                                    name={isProfileOpen ? "keyboard_arrow_down" : "keyboard_arrow_up"}
                                    width={20}
                                    height={20}
                                    color="#003366"
                                    className={`flip-icon ${isProfileOpen ? "flip-up" : "flip-down"}`}
                                    />
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header;
